const annotate = RoughNotation.annotate;

document.addEventListener('DOMContentLoaded', function () {
  const elementsToAnnotate = document.querySelectorAll('[SFAnnotate]');

  elementsToAnnotate.forEach(function (element) {
    var myAnnotation = annotate(element, {
      color: element.getAttribute('data-color'),
      type: element.getAttribute('data-type'),
      strokeWidth: parseInt(element.getAttribute('data-stroke-width'), 10),
      animationDuration: 2400,
    });

    myAnnotation.show();
  });
});
